import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const cryptoApi = {
  getCryptos: () => api.get('/cryptos'),
  getRates: () => api.get('/exchange/rates'),
  getReviews: () => api.get('/reviews'),
  getChart: (symbol, days) => api.get(`/prices/chart/${symbol}?days=${days}`),
  lockRate: (data) => api.post('/exchange/lock-rate', data),
  getRateLock: (lockId) => api.get(`/exchange/lock-rate/${lockId}`),
  swap: (data) => api.post('/exchange/swap', data),
};

export const walletApi = {
  getWallet: () => api.get('/wallet'),
  getTransactions: () => api.get('/transactions'),
};

export const businessApi = {
  createKey: (data) => api.post('/business/keys', data),
  getKeys: () => api.get('/business/keys'),
};

export const adminApi = {
  getUsers: () => api.get('/admin/users'),
  getTransactions: () => api.get('/admin/transactions'),
};

export const privacyApi = {
  getPolicy: () => api.get('/legal/confidentiality'),
};

export default api;